"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BulkDataAliasService", {
    enumerable: true,
    get: function() {
        return BulkDataAliasService;
    }
});
const _common = require("@nestjs/common");
const _dataHelpers = require("~/helpers/dataHelpers");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let BulkDataAliasService = class BulkDataAliasService {
    async getModelViewBase(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        const source = await _models.Source.get(context, model.source_id);
        return {
            model,
            view,
            source
        };
    }
    async executeBulkOperation(context, param) {
        const { model, view, source } = await this.getModelViewBase(context, param);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        return await baseModel[param.operation].apply(null, param.options);
    }
    // todo: Integrate with filterArrJson bulkDataUpdateAll
    async bulkDataInsert(context, param) {
        (0, _dataHelpers.validateV1V2DataPayloadLimit)(context, param);
        return await this.executeBulkOperation(context, _extends({}, param, {
            operation: 'bulkInsert',
            options: [
                param.body,
                {
                    cookie: param.cookie,
                    foreign_key_checks: param.foreign_key_checks,
                    skip_hooks: param.skip_hooks,
                    raw: param.raw,
                    allowSystemColumn: param.allowSystemColumn,
                    undo: param.undo
                }
            ]
        }));
    }
    // todo: Integrate with filterArrJson bulkDataUpdateAll
    async bulkDataUpdate(context, param) {
        (0, _dataHelpers.validateV1V2DataPayloadLimit)(context, param);
        return await this.executeBulkOperation(context, _extends({}, param, {
            operation: 'bulkUpdate',
            options: [
                param.body,
                {
                    cookie: param.cookie,
                    raw: param.raw,
                    allowSystemColumn: param.allowSystemColumn,
                    apiVersion: param.apiVersion
                }
            ]
        }));
    }
    // todo: Integrate with filterArrJson bulkDataUpdateAll
    async bulkDataUpdateAll(context, param) {
        var _param_internalFlags;
        return await this.executeBulkOperation(context, _extends({}, param, {
            operation: 'bulkUpdateAll',
            options: [
                param.query,
                param.body,
                {
                    cookie: param.cookie,
                    skip_hooks: (_param_internalFlags = param.internalFlags) == null ? void 0 : _param_internalFlags.skipHooks
                }
            ]
        }));
    }
    async bulkDataDelete(context, param) {
        (0, _dataHelpers.validateV1V2DataPayloadLimit)(context, param);
        return await this.executeBulkOperation(context, _extends({}, param, {
            operation: 'bulkDelete',
            options: [
                param.body,
                {
                    cookie: param.cookie
                }
            ]
        }));
    }
    // todo: Integrate with filterArrJson bulkDataDeleteAll
    async bulkDataDeleteAll(context, param) {
        var _param_internalFlags;
        return await this.executeBulkOperation(context, _extends({}, param, {
            operation: 'bulkDeleteAll',
            options: [
                param.query,
                {
                    cookie: param.req,
                    skip_hooks: (_param_internalFlags = param.internalFlags) == null ? void 0 : _param_internalFlags.skipHooks
                }
            ]
        }));
    }
    async bulkDataUpsert(context, param) {
        (0, _dataHelpers.validateV1V2DataPayloadLimit)(context, param);
        return await this.executeBulkOperation(context, _extends({}, param, {
            operation: 'bulkUpsert',
            options: [
                param.body,
                {
                    cookie: param.cookie,
                    undo: param.undo
                }
            ]
        }));
    }
};
BulkDataAliasService = _ts_decorate([
    (0, _common.Injectable)()
], BulkDataAliasService);
